// extracted by mini-css-extract-plugin
module.exports = {"List":"StekList_List__wzrED","Cards":"StekList_Cards__2CH2G","Number":"StekList_Number__caApy"};